// helpers
import { setCookie, getCookie } from 'shared/helpers/utils';

// constants
const REVIEW_TO_BE_LIKED = 'REVIEW_TO_BE_LIKED';
// const SET = "set";

export enum STATUS {
  SET,
  CALLED,
  FAILED,
}

export const statusValues: { [key: string]: string } = {
  [STATUS.SET]: 'set',
  [STATUS.CALLED]: 'called',
  [STATUS.FAILED]: 'failed',
};

export const HELPFUL_TEXTS = {
  ADD: 'add',
  REMOVE: 'remove',
  HELPFUL: 'Helpful',
  HELPFUL_REVIEW: 'helpful review',
  HELPFUL_PREFIX: 'You and',
  HELPFUL_SUFIX: 'people found this helpful',
  HELPFUL_FAILED_MESSAGE: 'HELPFUL_REVIEW_API_FAILED',
};

// save review to be liked after login on session storage
export const setReviewToBeLiked = (reviewId: string) => {
  const review = {
    id: reviewId,
    apiCalledStatus: statusValues[STATUS.SET],
  };

  try {
    window.sessionStorage.setItem(REVIEW_TO_BE_LIKED, JSON.stringify(review));
  } catch (err) {
    setCookie(REVIEW_TO_BE_LIKED, JSON.stringify(review), 1);
  }
};

// get review to be liked from session
export const getStoredReviewToBeLiked = () => {
  try {
    const review = window.sessionStorage.getItem(REVIEW_TO_BE_LIKED);
    return JSON.parse(review || '{}');
  } catch (err) {
    return JSON.parse(getCookie(REVIEW_TO_BE_LIKED) || '{}');
  }
};

// remove review to be liked from session
export const removeReviewToBeLiked = () => {
  try {
    window.sessionStorage.removeItem(REVIEW_TO_BE_LIKED);
  } catch (err) {
    setCookie(REVIEW_TO_BE_LIKED, '{}', -1);
  }
};

// update status of review to be liked in session
export const updateReviewToBeLiked = (status: STATUS) => {
  let existingReview = getStoredReviewToBeLiked();

  existingReview.apiCalledStatus = statusValues[status];

  try {
    sessionStorage.setItem(REVIEW_TO_BE_LIKED, JSON.stringify(existingReview));
  } catch (err) {
    setCookie(REVIEW_TO_BE_LIKED, JSON.stringify(existingReview), 1);
  }
};
